module.exports = __webpack_public_path__ + "static/goth-name-generator-bbf04f8fbb20ab59428bfd9c7c7ba69c.svg";